import axios from 'axios';

const submitFarmerFeedback = (payload) => {
  const loggedInUser = JSON.parse(localStorage.getItem('user') || '{}');

  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/farmer/feedback`, {
      ...payload,
      submittedBy: loggedInUser.fullName || loggedInUser.username || '',
      submittedByUserId: loggedInUser._id || loggedInUser.id || '',
    })
    .then((res) => res)
    .catch((err) => err);
};

export default submitFarmerFeedback;
